import { translate } from 'i18n';
import { useMemo } from 'react';
import { DataAttributeList, FloatingBox, formatNumber } from 'ui';
import {
  CheckBoxOutlined,
  ClassOutlined,
  LocalShippingOutlined,
  LocationOnOutlined,
  MapOutlined,
  ScaleOutlined,
  WarehouseOutlined,
} from 'ui/icons';

export const QualityReportSummary = ({
  originCountry,
  material,
  grade,
  availableTonnage,
  estimatedDeliveryDate,
  tonnesPerLoad,
  deliveryLocation,
}: {
  originCountry?: string;
  material: string;
  grade: string;
  availableTonnage?: string;
  estimatedDeliveryDate?: string;
  tonnesPerLoad?: string;
  deliveryLocation?: string;
}) => {
  const details = useMemo(() => {
    const qualityReportDetails = [
      {
        fullRow: true,
        icon: ClassOutlined,
        subtitle: material,
        title: translate('backlog.qualityReportSummary.titles.material', { namespace: 'features' }),
      },
      {
        fullRow: false,
        icon: CheckBoxOutlined,
        subtitle: grade,
        title: translate('backlog.qualityReportSummary.titles.materialGrade', { namespace: 'features' }),
      },
    ];

    if (originCountry) {
      qualityReportDetails.push({
        fullRow: false,
        icon: MapOutlined,
        subtitle: originCountry,
        title: translate('backlog.qualityReportSummary.titles.location', { namespace: 'features' }),
      });
    }

    if (availableTonnage) {
      qualityReportDetails.push({
        fullRow: false,
        icon: WarehouseOutlined,
        subtitle: formatNumber(availableTonnage, {
          style: 'ton',
        }),
        title: translate('backlog.qualityReportSummary.titles.availableMaterial', { namespace: 'features' }),
      });
    }

    if (tonnesPerLoad) {
      qualityReportDetails.push({
        fullRow: false,
        icon: ScaleOutlined,
        subtitle: formatNumber(tonnesPerLoad, {
          style: 'ton',
        }),
        title: translate('backlog.qualityReportSummary.titles.tonnesPerLoad', { namespace: 'features' }),
      });
    }

    if (estimatedDeliveryDate) {
      qualityReportDetails.push({
        fullRow: false,
        icon: LocalShippingOutlined,
        subtitle: estimatedDeliveryDate,
        title: translate('backlog.qualityReportSummary.titles.estimatedDelivery', { namespace: 'features' }),
      });

      if (deliveryLocation) {
        qualityReportDetails.push({
          fullRow: false,
          icon: LocationOnOutlined,
          subtitle: deliveryLocation,
          title: translate('backlog.qualityReportSummary.titles.deliveryLocation', { namespace: 'features' }),
        });
      }
    }

    return qualityReportDetails;
  }, [material, grade, originCountry, availableTonnage, tonnesPerLoad, estimatedDeliveryDate, deliveryLocation]);

  return (
    <FloatingBox>
      <DataAttributeList dataPoints={details} />
    </FloatingBox>
  );
};
